import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { formatINR } from "../lib/api";

// PUBLIC display: NO brand/tenant name, NO building name. Show category + city + area + ID.
export default function PropertyCard({ p, testIdPrefix = "property-card" }) {
  const code = p.code || `ZPL${(p.id || "").slice(0, 4).toUpperCase()}`;
  const category = p.tenant_industry || p.property_type || "Commercial Asset";

  return (
    <Link
      to={`/properties/${p.id}`}
      className="group block rounded-2xl border border-neutral-200 bg-white overflow-hidden hover:-translate-y-1.5 hover:shadow-soft transition-all duration-300"
      data-testid={`${testIdPrefix}-${p.id}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-neutral-100">
        <img src={p.image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute bottom-3 left-3 inline-flex items-center gap-1.5 bg-white/95 backdrop-blur px-3 py-1.5 rounded-full text-sm font-semibold shadow-soft">
          <span className="w-2 h-2 rounded-full bg-emerald-500" />
          <span className="text-brand">{p.roi}% Yield</span>
        </div>
        <div className="absolute top-3 left-3 inline-flex items-center gap-1 bg-white/85 backdrop-blur px-2 py-0.5 rounded-md text-[9px] font-mono font-medium tracking-wider shadow-soft text-neutral-500">
          {code}
        </div>
      </div>

      <div className="p-5">
        <div className="text-center">
          <div className="font-heading text-xl font-medium tracking-tight">{category}</div>
          <div className="flex items-center justify-center gap-1 text-sm text-neutral-500 mt-1">
            <MapPin className="w-3.5 h-3.5" />
            <span>{p.area}, {p.city}</span>
          </div>
        </div>

        <div className="mt-5 grid grid-cols-3 gap-3 text-sm border-t border-neutral-100 pt-4">
          <div className="text-center">
            <div className="label-tiny">Carpet</div>
            <div className="font-medium text-neutral-900 mt-0.5">{p.carpet_area?.toLocaleString("en-IN")}<span className="text-xs text-neutral-400"> sqft</span></div>
          </div>
          <div className="text-center bg-brand-50 rounded-lg py-1">
            <div className="label-tiny text-brand">Yield</div>
            <div className="font-medium text-brand-700 mt-0.5">{p.roi}%</div>
          </div>
          <div className="text-center">
            <div className="label-tiny">Lease</div>
            <div className="font-medium text-neutral-900 mt-0.5">{p.lease_period_years} yrs</div>
          </div>
        </div>

        <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
          <div><div className="label-tiny">Monthly Rent</div><div className="font-medium text-neutral-900">{formatINR(p.monthly_rent)}</div></div>
          <div><div className="label-tiny">Asking Price</div><div className="font-medium text-neutral-900">{formatINR(p.asking_price)}</div></div>
        </div>

        <div className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand group-hover:gap-2.5 transition-all">
          View Details & Contact <ArrowUpRight className="w-4 h-4" />
        </div>
      </div>
    </Link>
  );
}
